import { idsSelectorsReducer } from '@entities/common/IdsSelector/reducer';
import { savedDataReducer } from '@entities/common/savedData/reducer';
import { combineReducers } from 'redux';
import { colorTagReducer } from './color-tags';
import { groupReducer } from './groups';
import { platformSettingsReducer } from './platform-settings';
import { tagReducer } from './tags';
import { webSettingsReducer } from './web-settings';

export { useModules, moduleApi } from './modules';

export { useTags, tagsByModuleApi } from './tags';

export { useColorTag, useColorTags, colorTagsApi } from './color-tags';

export { useWebSettingsModel } from './web-settings';
export { usePlatformSettingsModel } from './platform-settings';

export const commonReducer = combineReducers({
  colorTags: colorTagReducer,
  tags: tagReducer,
  groups: groupReducer,
  webSettings: webSettingsReducer,
  platformSettings: platformSettingsReducer,
  idsSelectors: idsSelectorsReducer,
  savedData: savedDataReducer,
});
